import React from 'react'
import {
  CDropdown,
  CDropdownItem,
  CDropdownMenu,
  CDropdownToggle,
} from '@coreui/react'

type NavDropDownOption =
{
  header?:boolean
  content:() => React.ReactNode
  disabled?:boolean
  onClick: () => void
}

type Props =
{
  items:NavDropDownOption[]
  itemKey:(v:NavDropDownOption,i:number) => string
}
export default class NavDropDown extends React.PureComponent<Props>
{
  render()
  {
    return (
      <CDropdown
        inNav
        className="c-header-nav-item mx-2"
      >
        <CDropdownToggle className="c-header-nav-link" caret={ false }>
          { this.props.children }
        </CDropdownToggle>
        <CDropdownMenu placement="bottom-start">
          {
            this.props.items.map((v,i) =>
              <CDropdownItem
                disabled={ v.disabled }
                key={ this.props.itemKey(v,i) }
                onClick={ () => v.onClick() }
              >
                { v.content() }
              </CDropdownItem>
            )
          }
        </CDropdownMenu>
      </CDropdown>
    )
  }
}